(function (app, ng) {
    app.component("marketingSourcesComponent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Dashboard/Components/MarketingSources/marketing-sources.template.html",
            controller: 'marketingSourcesController',
            bindings: {
                startDate: "<",
                endDate: "<"
            }
        })
        .controller('marketingSourcesController',
            ["_", "chartColors", "$filter", "marketingTrackerSalesTrackerDashboardApi", "$q", "permissionService",
                function (_, chartColors, $filter, marketingTrackerSalesTrackerDashboardApi, $q, permissionService) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: {
                            loading: false
                        },
                        charts: {
                            chart1: { data: [0] }
                        },
                        colors: chartColors,
                        marketingSourcesData: {
                            MarketingRows: [],
                            TotalsRow: {}
                        },
                        canSeeRevenue: !!permissionService.hasOnePermission("SalesTrackerRevenue:View"),
                    });

                    _resetRevenueBreakdown = function (dataGroup) {
                        var dataArray = $filter('orderBy')(dataGroup, 'SourceName');
                        dataArray.forEach(function (a, i) { a.Index = i; })
                        // Added to allow filtering of sources with no data, and maintain index position for color selection
                        var dataArrayFiltered = _.filter(dataArray, function (a) { return !!a.TotalRoiRevenue })
                        var dataLabels = dataArrayFiltered.map(function (a) { return a.SourceName; });
                        var dataShortLabels = dataArrayFiltered.map(function (a) { return _textTruncate(a.SourceName, 20, '...'); });
                        var dataInfo = dataArrayFiltered.map(function (a) { return a.TotalRoiRevenue; });
                        var dataColors = ng.copy($ctrl.colors);
                        var dataIndexes = dataArrayFiltered.map(function (a) { return a.Index; });
                        var dataIndexedColors = dataIndexes.map(function (a) { return dataColors[a]; });

                        $ctrl.charts.chart1 = {
                            options: {
                                cutoutPercentage: 75,
                                legend: {
                                    display: false,
                                    position: "bottom",
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function (obj) {
                                            return dataLabels[obj.index] + ': ' + $filter('currency')(dataInfo[obj.index], '$', 0);
                                        }
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: true
                            },
                            shortLabels: dataShortLabels,
                            labels: dataLabels,
                            data: Object.values(dataInfo),
                            colors: dataIndexedColors.map(function (color) {
                                return {
                                    backgroundColor: color,
                                    hoverBackgroundColor: color,
                                    pointBackgroundColor: color,
                                    pointHoverBackgroundColor: color,
                                    borderColor: color,
                                    hoverBorderColor: color,
                                    pointBorderColor: color,
                                    pointHoverBorderColor: color,
                                }
                            }),
                            type: 'doughnut'
                        };
                    };

                    _textTruncate = function (fullString, length, ending) {
                        if (length === null) {
                            length = 50;
                        }
                        if (ending === null) {
                            ending = '...';
                        }
                        var strLength = !!fullString ? fullString.length : 0;
                        if (strLength > length) {
                            return fullString.substring(0, length - ending.length) + ending;
                        } else {
                            return fullString;
                        }
                    };

                    $ctrl.$onInit = function () {
                        $ctrl.ui.loading = true;

                        const promises = [
                            marketingTrackerSalesTrackerDashboardApi.getMarketingSourcesByDate($ctrl.startDate, $ctrl.endDate),
                        ];
                        $q.all(promises)
                            .then(function (responses) {
                                $ctrl.marketingSourcesData.TotalsRow = responses[0].pop();
                                $ctrl.marketingSourcesData.MarketingRows = responses[0];
                                _resetRevenueBreakdown($ctrl.marketingSourcesData.MarketingRows);
                            })
                            .catch(function (error) {
                                console.log(error.data)
                            })
                            .finally(function () {
                                $ctrl.ui.loading = false;
                            });
                    }
                }
            ]);
})(window.app, window.angular); //jshint ignore:line